module.exports = __webpack_public_path__ + "static/media/Ds2.4a06faf0.jpeg";